//Enum només de front, són per definir què ensenyem a la pàgina de vincles
export enum PartnersPageModes {
    list = "list",
    add = "add",
    link = "link",
    none = "none"
}
